module.exports = __webpack_public_path__ + "static/media/asset6.5a211dfc.svg";